import React from 'react';
import DesktopFooter from './DesktopFooter';
import MobileFooterSticky from './MobileFooterSticky';

interface FooterProps {
    isAuthenticated: boolean;
}

const Footer: React.FC<FooterProps> = ({ isAuthenticated = false }) => {
    return (
        <>
            <div>
                {/* Desktop footer */}
                <DesktopFooter />

                {/* Mobile footer */}
                <MobileFooterSticky isAuthenticated={isAuthenticated} />
            </div>
        </>
    );
};

export default Footer;